import { render, staticRenderFns } from "./user_price.vue?vue&type=template&id=71861c4c&scoped=true&"
import script from "./user_price.vue?vue&type=script&lang=js&"
export * from "./user_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71861c4c",
  null
  
)

export default component.exports